import React from 'react'
import firebase from './../Firestore'
import store from '../../store';
import { CookiesProvider } from 'react-cookie';


import FormularioDatosCliente from './FormularioDatosCliente'

class Carrito extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.detalleProducto = this.detalleProducto.bind(this);
    this.state = {
      productosEnCarrito: [],
      vieneDelCarrito: false,
      muestraFormulario: false
     };
  }



onClick(e){
  //console.log("sigue comprando")
  if(e.currentTarget.id === "irListado"){
    store.dispatch({
      type: "MENU_PRINCIPAL",
      carritoVacio: false
    })
  } else if(e.currentTarget.id === "pedidoCompleto"){
    this.setState({muestraFormulario: true})
  }

}

componentWillMount(){

    //document.getElementByTagName("FormularioDatosCliente").display = "none"

    let pedidoId = sessionStorage.getItem("nroPedido");
    let db = firebase.firestore()


    let currentComponent = this;

    //console.log("lee en db los prod en carrito")

    db.collection("pedidoDetalle").where("pedidoId", "==", pedidoId)
        .onSnapshot(function(querySnapshot) {
        //.get()
        //.then(function(querySnapshot) {

          currentComponent.setState(
            {

              productosEnCarrito: querySnapshot.docs.map(doc => {
                return {
                  "id": doc.id,
                  "pedidoId": doc.data().pedidoId,
                  "productoId": doc.data().productoId,
                  "tamano": doc.data().tamano,
                  "cantidad": doc.data().cantidad,
                  "esAdicional": doc.data().esAdicional,
                  "confirmado": doc.data().confirmado
                }
              })
            }
          );

        })
}


// shouldComponentUpdate(nextProps, nextState) {
//   //console.log("nextState.productosEnCarrito.length y actual", nextState.productosEnCarrito.length, this.state.productosEnCarrito.length)
//   if (nextState.productosEnCarrito.length === 0) {
//      //store.dispatch({type: "SIGUE_COMPRANDO"});
//
//      store.dispatch({type: "CARRITO_VACIO"});
//      return false;
//    } else{
//   return true;
//    }
// }


componentWillUnmount(){
  //console.log("en carrito WillUnmount")
  this._isMounted = false;

}

detalleProducto(esAdicional, arr, value, propiedad1, propiedad2="") {

  if(esAdicional){
    if(propiedad1 === "nombreCategoria"){
      return "Adicional"
    }else{
      arr = this.props.adicionalDetalle;
    }
  }

  for (var i=0, iLen=arr.length; i<iLen; i++) {
    if(esAdicional){
      if (arr[i].id === value) return arr[i].data[propiedad1];
    } else if(propiedad1 === "nombreCategoria"){
      if (arr[i].id === value) return arr[i].nombre;
    }

    if(propiedad2 === ""){
      if(esAdicional){
        if (this.props.adicionalDetalle[i].id === value) return this.props.adicionalDetalle[i].propiedad1;
      }
      else if (arr[i].id === value){
          return arr[i].data[propiedad1];
      }
    }else{
      if (arr[i].id === value) return arr[i].data[propiedad1][propiedad2];
    }
  }
}

onEliminaItem(event) {
  let db = firebase.firestore()

  db.collection("pedidoDetalle").doc(event.currentTarget.id).delete().then(function() {
    //  console.log("Document successfully deleted!");
  }).catch(function(error) {
      console.error("Error removing document: ", error);
  });

  const arrayCopy = this.state.productosEnCarrito.filter((row) => row.id !== event.currentTarget.id);
  this.setState({productosEnCarrito: arrayCopy});

  if (arrayCopy.length === 0) {
    store.dispatch({
      type: "MENU_PRINCIPAL",
      carritoVacio: true
    })
  }

}

  render() {

      var subTotal = [];
      var cantidad = [];
      var granTotal;
      //let iconoQuitar = '<i id="resta" className="fas fa-times-circle text-danger mr-2"></i>';

      let ItemsNombre = []

      if(this.state.productosEnCarrito) {

        ItemsNombre = this.state.productosEnCarrito.map((todo, i) => {
          return {
            "id": todo.id,
            "categoria": this.detalleProducto(todo.esAdicional, this.props.cat, this.detalleProducto(todo.esAdicional, this.props.productoDetalle, todo.productoId, "categoriaID" ), "nombreCategoria" ),
            "tamano": todo.tamano,
            "nombre": this.detalleProducto(todo.esAdicional, this.props.productoDetalle, todo.productoId, "nombre" ),
            "cantidad": todo.cantidad,
            "precio": this.detalleProducto(todo.esAdicional, this.props.productoDetalle, todo.productoId, "precio", todo.tamano ),
            "productoId": todo.productoId,
            "esAdicional": todo.esAdicional
          }
        })

        function compare(a,b) {
          if (a.categoria < b.categoria)
            return -1;
          if (a.categoria > b.categoria)
            return 1;
          return 0;
        }

        let ItemsOrdenados = ItemsNombre.sort(compare);

        var Items = ItemsOrdenados.map((todo, i) =>

                      <tr id={todo.id} key={todo.id} onClick={event => this.onEliminaItem(event)}>
                      <td>
                        <i id="resta" className="fas fa-times-circle text-danger mr-2"></i>
                        <span className="h6 mr-1">{todo.categoria}</span>
                        <span className="mr-1"><em>{todo.tamano}</em></span>
                        <span>{todo.nombre}</span>
                      </td>
                      <td>{cantidad[i] = todo.cantidad}</td>
                      <td>$ {subTotal[i] = cantidad[i] * todo.precio}</td>
                    </tr>
        )
      }else{
        return ""
      }

      return (
        <div>

        {this.state.productosEnCarrito.length > 0 &&
          <div>
          <table className="table table-sm">
            <thead>
              <tr>
                <th scope="col">Items seleccionados</th>
                <th scope="col">Cant.</th>
                <th scope="col">SubTotal</th>
              </tr>
            </thead>
            <tbody>
              {Items}
              <tr>
                <td></td>
                <td></td>
                <td><strong>$ {granTotal = subTotal.reduce((a, b) => a + b, 0)}</strong></td>
              </tr>

            </tbody>
          </table>


          {!this.state.muestraFormulario &&
            <div className="text-center d-flex flex-column">
              <button id="irListado" type="button" onClick={event => this.onClick(event)} className="btn btn-info mb-3 mx-1"><i className="fas fa-shopping-cart"></i> Seguir agregando ítems</button>
              <button id="pedidoCompleto" type="button" onClick={event => this.onClick(event)} className="btn btn-success mx-1"><i className="fas fa-clipboard-check"></i> Mi pedido esta completo!</button>
            </div>
          }

          {this.state.muestraFormulario &&
            <div>
              <hr />
              <CookiesProvider>
                <FormularioDatosCliente uid={this.props.uid} total={granTotal} />
              </CookiesProvider>
            </div>
          }
          </div>

        }
        </div>
      )
    }

  }

export default Carrito
